module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "events-block"
  }, [_c('div', {
    staticClass: "justify-content-between"
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "divider-vertical"
  }), _vm._v(" "), _c('div', {
    staticClass: "link"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'archivedIssues'
      }
    }
  }, [_vm._v("View Archives >")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "events-list"
  }, [_c('span', {
    staticClass: "event"
  }, [_c('span', {
    staticClass: "date"
  }, [_vm._v("\n          August 7-12, 2016\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "name"
  }, [_vm._v("\n          Oncotarget journal is a Sponsor of Rare Cells in Cordon Conference, South Hadley, MA.\n        ")])]), _vm._v(" "), _c('span', {
    staticClass: "divider-vertical"
  }), _vm._v(" "), _c('span', {
    staticClass: "event"
  }, [_c('span', {
    staticClass: "date"
  }, [_vm._v("\n          September 25-28, 2016\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "name"
  }, [_vm._v("\n          Circulation Cordon Research Conference, South Hadley, MA.\n        ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c9330c3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main-layout/header-area/HeaderEventsBlockComponent.vue
// module id = 1445
// module chunks = 1